import { createSelector } from "reselect";
//EXTRACT THE PART OF THE STATE
const getData = state => {
  const profile = state.user.profile;
  try {
    return profile.isFemale;
  } catch (error) {
    return true;
  }
};
//VERIFY IF THE JWT IS SET
const getMyGender = createSelector(getData, gender => gender);
export default getMyGender;



// WEBPACK FOOTER //
// ./src/_selectors/userSelectors/getMyGender.js